import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";

import { fetchEarnedPoints } from "../../redux/slice/earnedPoints";
import { formatIndianNumber } from "../../utils/common";

import "./PointHistory.scss";
import NoDataComp from "../../component/NoDataComp";
import Spinner from "../../component/spinner/Spinner";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
import clockIcon from "../../assets/images/last_minute_deal.svg";

const ExpiredPoints = ({ filteredExpiredPoints, filteredExpiringPoints }) => {
  const dispatch = useDispatch();
  const { earnedPointsData, loading } = useSelector(
    (state) => state.earnedPoints,
  );

  useEffect(() => {
    if (earnedPointsData?.length === 0) {
      dispatch(fetchEarnedPoints());
    }
    // eslint-disable-next-line
  }, []);

  const hasData =
    filteredExpiredPoints?.length > 0 || filteredExpiringPoints?.length > 0;

  return (
    <>
      <div className="tabTable">
        <div className="border_bottom_section">
          {/* Expiring Points Section */}
          {filteredExpiringPoints?.length > 0 &&
            filteredExpiringPoints.map((item, index) => {
              return (
                <React.Fragment key={`expiring-${index}`}>
                  <div className="d-flex justify-content-between transction_list expiring">
                    <div className="hotel_booking_details d-flex align-items-center">
                      <div>
                        <h1>Points Expiring Soon</h1>
                        <div className="date_expire">
                          <img src={clockIcon} alt="" /> Expiring on:{" "}
                          {item?.expiry_date
                            ? moment(item?.expiry_date).format("DD MMM YYYY")
                            : "Not Available"}
                        </div>
                      </div>
                    </div>
                    <div className="points_gold">
                      <p
                        className="high_light_text"
                        style={{ display: "flex", color: "#FFA500" }}
                      >
                        {formatIndianNumber(item?.points)}
                        {/* <img src={gold_rupe_icon_md} alt="" /> */}
                      </p>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          {/* Expired Points Section */}
          {filteredExpiredPoints?.length > 0 &&
            filteredExpiredPoints.map((item, index) => {
              return (
                <React.Fragment key={`expired-${index}`}>
                  <div className="d-flex justify-content-between transction_list expired">
                    <div className="hotel_booking_details d-flex align-items-center">
                      <div>
                        <h1>Points Expired</h1>
                        <div className="date_expire">
                          <img src={clockIcon} alt="" /> Expired on:{" "}
                          {item?.expired_on
                            ? moment(item?.expired_on).format("DD MMM YYYY")
                            : "Not Available"}
                        </div>
                      </div>
                    </div>
                    <div className="points_gold">
                      <p
                        className="high_light_text"
                        style={{ display: "flex", color: "#8F0000" }}
                      >
                        -{formatIndianNumber(item?.points)}{" "}
                        {/* <img src={gold_rupe_icon_md} alt="" /> */}
                      </p>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}

          {!hasData && (loading ? null : <NoDataComp />)}
        </div>
      </div>
      {loading ? (
        <div className="spinner_table_height">
          <Spinner color="black" />
        </div>
      ) : null}
    </>
  );
};

export default ExpiredPoints;
